export default __webpack_public_path__ + "static/List-of-acceptable-documents-a3fb2cf8e6ae7bafe48b9541f506b292.pdf";